import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { StyleService } from '../../services/style.service';
@Component({
  selector: 'app-number-field',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility && !field.dynamic">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <input class="form-control focus-color" type="number" [ngStyle]="_styleService.applyStyle(field)" (keypress)="numberOnly($event)" [disabled]="isDisabled()" value="{{field.value}}" placeholder="Enter numbers here..." (change)="onChange($event.target)" (mouseenter)="mouseEnter($event.target)" (mouseleave)="mouseLeave($event.target)">
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
<div [formGroup]="group" *ngIf="field.dynamic && field.style.visibility" class="dynamic-property">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <div *ngFor="let x of field.value; let i = index;trackBy:trackByIndex;" class="inputfields">
      <input class="form-control dynamic-input focus-color" (keypress)="numberOnly($event)" type="number" [disabled]="isDisabled()" [(ngModel)]="field.value[i]" [ngModelOptions]="{standalone :true}" placeholder="Enter numbers here..." (change)="onChangeForDynamic($event.target, i)">
        <ng-container *ngIf="deleteShow">
      <div class="btn delete-item for-some-fields" [ngClass]="{'pointer-events' : !field.style.editability}" (click)="deletShortText(i)"><img src="assets/rff-images/delete-dynamic.svg"></div>
      </ng-container>
    </div>
    <span class="error-message dynamic-ermsg" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
    <div class="btn-dynamic" [ngClass]="{'pointer-events' : !field.style.editability}">
      <div class="btn btn-default" (click)="dynamicShortText()"><img src="assets/rff-images/add-img.svg"> Add another field</div>
    </div>
    </div>
    `,
  styles: []
})
export class NumberFieldComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  deleteShow = false;
  constructor(
    private _validationService: ValidationService,
    private _styleService: StyleService
  ) { }
  onChange(event) {
    this.field.value = event.value;
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && charCode != 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (this.field.data && this.field.data.format && this.field.data.format === 'decimal') {
      if (this.field.value && this.field.value.split('.')[1] && this.field.data.max && (parseInt(this.field.data.max) < (this.field.value.split('.')[1]).length)) {
        return false;
      }
      return true;
    } else if (charCode === 46) {
      return false;
    }
    return true;
  }
  mouseEnter(event) {
    this.field.value = event.value;
  }
  mouseLeave(event) {
    this.field.value = event.value;
  }

  // dynamic number field
  onChangeForDynamic(event, index) {
    this.field.value = Object.assign([], this.field.value, {
      [index]: event.value
    });
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value[this.field.id];
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  trackByIndex(index: number) {
    return index;
  }
  dynamicShortText() {
    this.field.value.push('');
    this.deleteShow = true;
  }
  deletShortText(i) {
    this.field.value.splice(i, 1);
    if (i === 1) {
      this.deleteShow = false;
    }
  }
  ngOnInit() {
    if (this.field.value === undefined && this.field.dynamic) {
      this.field.value = ['']
    };
    if (this.field.value === undefined && !this.field.dynamic && this.field.value !== " ") {
      this.field.value = '';
    }
    if (this.field.dynamic && this.field.value.length > 1) {
      this.deleteShow = true;
    }
  }
  isDisabled(): boolean {
    if (!this.field.style.editability) return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/number-field/number-field.component.ts